import { useAuth } from '@/contexts';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/es';

dayjs.extend(utc);
dayjs.locale('es');

export interface MaxBookingDateValidationResult {
  shouldShowBanner: boolean;
  isPastDate: boolean;
  formattedDate: string;
}

export const useMaxBookingDateValidation = (): MaxBookingDateValidationResult => {
  const { session } = useAuth();
  const vendor = session?.vendor;

  const maxBookingFixedDate = vendor?.max_booking_fixed_date;

  if (!maxBookingFixedDate) {
    return {
      shouldShowBanner: false,
      isPastDate: false,
      formattedDate: ''
    };
  }

  const daysUntilLimit = dayjs
    .utc(maxBookingFixedDate)
    .startOf('day')
    .diff(dayjs.utc().startOf('day'), 'day');

  // Ya pasó: la agenda quedó cerrada (disponibilidad vacía en cyclone) sin que
  // el vendor lo sepa. Se trata aparte, con mayor severidad, en Layout.tsx.
  const isPastDate = daysUntilLimit < 0;
  // Próxima a vencer pero todavía no pasó: aviso informativo, a 14 días o menos.
  const shouldShowBanner = daysUntilLimit >= 0 && daysUntilLimit <= 14;

  // Format date in Spanish: "30 de noviembre"
  // Use UTC to avoid timezone shifts when displaying the date
  const formattedDate = dayjs.utc(maxBookingFixedDate).format('D [de] MMMM');

  return {
    shouldShowBanner,
    isPastDate,
    formattedDate
  };
};
